/** Display helpers for candidate rows in lists and modals. */

export function formatCandidatePhone(candidate) {
  const raw = String(
    candidate?.displayPhone || candidate?.contact?.phone || candidate?.phone || ''
  ).trim();
  if (!raw) return '—';
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 10) {
    return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
  }
  if (digits.length === 12 && digits.startsWith('91')) {
    return `+91 ${digits.slice(2, 7)} ${digits.slice(7)}`;
  }
  return raw;
}

export function candidateDisplayName(candidate) {
  if (!candidate) return '—';
  return (
    candidate.displayName ||
    candidate.personal?.name ||
    candidate.contact?.name ||
    candidate.contact?.email ||
    candidate.id ||
    '—'
  );
}

export function candidateSearchHaystack(candidate) {
  const c = candidate || {};
  return [
    candidateDisplayName(c),
    c.displayEmail,
    c.contact?.email,
    c.contact?.phone,
    c.displayPhone,
    c.id,
    c.displayLocation,
    c.location,
    c.personal?.city,
    c.personal?.state,
    c.displayExperience,
    c.profileHeading,
    ...(c.areasOfExpertise || []),
    ...(c.skills || [])
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}
